import React from "react";

interface IMenuLinesIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const MenuLinesIcon: React.FC<IMenuLinesIconProps> = ({
  size = 14,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M2 4h12M2 8h10M2 12h8"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
